<div
    class="message-form-container"
    [class.sender]="isSender"
    [class.receiver]="!isSender"
>
    @if (deletable && !teamsApp) {
        <button id="remove-attachment-button"
            class="close-button circle-icon small cancel"
            (click)="this.removeFormLink.emit(formLink)"
        >
            <app-icon class="cPointer" faIcon="fas fa-times"></app-icon>
        </button>
    }
    <div class="content-container">
        <div class="text-container">
            @if (name) {
                <span class="text-name">{{ name }}</span>
            }
            <span>{{ 'crews.channels.forms.fill-out-desc' | translate }}</span>
        </div>
        <app-icon class="file-icon" faIcon="fal fa-file-lines"></app-icon>
        @if (deletable && teamsApp) {
            <div class="teams-remove-container"
                (click)="this.removeFormLink.emit(formLink)"
                (mouseenter)="closeIcon = 'fas fa-times'"
                (mouseleave)="closeIcon = 'fal fa-times'"
            >
                <app-icon [faIcon]="closeIcon"></app-icon>
            </div>
        }
    </div>
</div>